import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgClass, NgIf, TitleCasePipe } from "@angular/common";
import { RippleModule } from "primeng/ripple";



@Component({
    selector: 'tag-chip',
    styleUrls: ['./tag-chip.component.scss'],
    template: `
    <span pRipple class="chip-stroked" (click)="onClick.emit($event)" [ngClass]="{ 'ic-left' : addable,  'ic-right' : !addable , 'primary' :primary}">
        
        <span class="icon-wrapper" *ngIf="addable">
            <span class="icon icon-plus-lg"></span>
        </span>

        <span class="chip-label">{{tag | titlecase}}</span>

        <span class="icon-wrapper" *ngIf="!addable">
            <span class="icon icon-g-cancel"></span>
        </span>
    </span>
    `,
    standalone: true,
    imports: [RippleModule, NgClass, NgIf, TitleCasePipe]
})
export class TagChipComponent {

    @Input() tag!: string;
    @Input() addable: boolean = false;
    @Input() primary:boolean = false;
    @Output() onClick: EventEmitter<MouseEvent>;


    constructor(){
        this.onClick = new EventEmitter<MouseEvent>();
    }

}
